import {type CliConfig} from '@sanity/cli-core'

/**
 * @deprecated Use `defineCliConfig` instead
 * @public
 */
export function createCliConfig(config: CliConfig): CliConfig {
  return config
}
